"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _EllipsisOptionComponent["default"];
  }
});

var _EllipsisOptionComponent = _interopRequireDefault(require("./EllipsisOptionComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }